import { LlmColumnModel } from '../llm-column.model';
import { makeSnapshotAction } from '@cotera/client/v0/columns/common-actions/snapshot-column.action';
import { SaveLlmColumnAction } from './save-llm-column.action';
import type { ExecuteContext } from '@cotera/client/v0/actions/framework/types';

export class LLMColumnSnapshotAction extends makeSnapshotAction(
  'Run LLM Column',
  LlmColumnModel,
  SaveLlmColumnAction
) {
  override async execute(input: {}, context: ExecuteContext) {
    const llmColumnModel = context.targetedModelOfType(LlmColumnModel);
    llmColumnModel?.runOnNewRowsClicked.set(true);
    return super.execute(input, context);
  }
}
